import React, {useEffect, useState} from "react";
import trendingProfile from "../../../../public/images/trendingProfile.svg";
import styles from "../../css/communitySubsections.module.css";
import {useDispatch, useSelector} from "react-redux";
import {PAGE_HASH_LOCATION} from "../../../app/utils/pages";
import ActionButtonContainer from "../../../shared/containers/ActionButtonContainer";
import copylink from "../../../../public/images/icons/CopyLinkIcon.svg";
import {getDate} from "../../../app/dashboard/utils/get-date";
import {getColor} from "../../../shared/utils/getColor";
import PopUpContainer from "../../../shared/components/PopUpContainer";
import AskEditQuestionPopup from "./CommunityPopUps/AskEditQuestionPopUp";
import {COMMUNITY_ACTION_TYPES} from "./communityReducer";
import {isMobileOnly} from "react-device-detect";
import {trendingQuestions} from "../../../shared/utils/sash-v2-api";

const CommunityTrending = () => {
    const [copiedQuestionId, setCopiedQuestionId] = useState(null);
    const userId = useSelector((state) => state.userReducer.userId);
    const [askPopUp, setAskPopUp] = useState(false);
    const dispatch = useDispatch();
    const trendingQuestion = useSelector((state) => state.communityReducer.trending);


    const handleSuccess = (response) => {
        dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_TRENDING,
            payload: response.data.trendingQuestions,
        });
    };

    const handleFailure = (error) => {
        console.error("Error:", error);
    };

    useEffect(() => {
        trendingQuestions(handleSuccess, handleFailure)
    }, [])

    const handleCopyLink = (questionId) => {
        const link = `${window.location.origin}/#community/?id=${questionId}`;
        navigator.clipboard.writeText(link).then(() => {
            setCopiedQuestionId(questionId);
            setTimeout(() => {
                setCopiedQuestionId(null);
            }, 1000);
        });
    };

    const handleQuestionClick = (itemId) => {
        window.location.href = window.location.origin + PAGE_HASH_LOCATION.community + `/?id=${itemId}`;
    };


    const handleAddQuestion = () => {
        if (!userId) {
            localStorage.setItem("isCommunity", true);
            window.location = "/app" + PAGE_HASH_LOCATION.login;
        } else {
            setAskPopUp(true);
        }
    };

    const closeAddPopUp = () => {
        setAskPopUp(false);
    }

    return (
        <>
            {
                !isMobileOnly ?
                    <div style={{height: '64vh'}} className={styles.subSectionsMain}>
                        <h4 style={{margin: "15px 0 15px 15px"}}>Trending</h4>
                        <div>
                            {trendingQuestion.map((thread) => {
                                return (
                                    <div key={thread._id} className={styles.questionItem}
                                         onClick={() => handleQuestionClick(thread._id)}>
                                        <div className={styles.subSectionIcon}>
                                            <img width={30} src={trendingProfile} alt="profile"/>
                                        </div>
                                        <div className={styles.questionDescription}>
                                            <p style={{fontWeight: "1000"}}>{thread.title}</p>
                                            <p>{thread.description}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    :
                    <div className={styles.trendingContainers}>
                        <div className={styles.headerContainers}>
                            <h1 style={{fontSize: '27px'}}>Trending</h1>
                            <ActionButtonContainer
                                buttonText={"+ Ask Question"}
                                fontSize={"16px"}
                                buttonWidth={"160px"}
                                marginTop={"-1px"}
                                handleClick={handleAddQuestion}
                            />
                        </div>

                        <div className={styles.questionsLists}>
                            {trendingQuestion.length > 0 ? (
                                trendingQuestion.map((item) => {
                                    const userId = item.user_id;
                                    const avatarColor = getColor(userId[0]);
                                    const userName = userId.split("@")[0];
                                    const createdDate = getDate(item.created_at);
                                    return (
                                        <div
                                            key={item._id}
                                            className={styles.questionCards}
                                            onClick={() => handleQuestionClick(item._id)}
                                        >
                                            <div className={styles.questionHeaders}>
                                                <div
                                                    className={styles.userAvatars}
                                                    style={{backgroundColor: avatarColor}}
                                                >
                                                <span>
                                                    {userId[0]?.toUpperCase()}
                                                </span>
                                                </div>
                                                <div className={styles.userDetails}>
                                                    <span className={styles.userNames}>{userName}</span>
                                                    <span className={styles.createdDates}>{createdDate}</span>
                                                </div>
                                                <div className={styles.questionActions}>
                    <span className={styles.answersCounts}>
                      {item.answer_count} {item.answer_count === 1 ? "Answer" : "Answers"}
                    </span>
                                                    <span className={styles.shareIcons}>
                      {copiedQuestionId === item._id ? (
                          <span className={styles.copiedText}>Copied!</span>
                      ) : (
                          <img
                              src={copylink}
                              alt="Copy link"
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleCopyLink(item._id);
                              }}
                          />
                      )}
                    </span>
                                                </div>
                                            </div>
                                            <h3 className={styles.questionTitles}>{item.title}</h3>
                                            <p className={styles.questionDescriptions}>{item.description}</p>
                                        </div>
                                    );
                                })
                            ) : (
                                <h3 style={{minHeight: '100vh'}}>No results found.</h3>
                            )}
                        </div>
                        {askPopUp && (
                            <PopUpContainer>
                                <AskEditQuestionPopup
                                    selectedThread={null}
                                    onClose={closeAddPopUp}/>
                            </PopUpContainer>
                        )}
                    </div>
            }

        </>
    );
};

export default CommunityTrending;
